import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

import LoginForm from './LoginForm';

export default class Login extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.updateUser = this.props.updateUser;
    this.successAlert = this.props.location.state && this.props.location.state.successAlert;

    // State
    this.state = {
      loggedIn: false,
    };
  }

  handleSuccessfulLogin = async (authData) => {
    const isLoggedIn = !!authData;
    this.setState({ loggedIn: isLoggedIn });

    // we don't have any other check here so if the login is successful we can return true.
    return isLoggedIn;
  }

  render() {
    return (
      this.state.loggedIn
        ? <Redirect to="/details" />
        : <LoginForm api={this.api} updateUser={this.updateUser} handleSuccessfulLogin={this.handleSuccessfulLogin} successAlert={this.successAlert} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/Login.jsx